import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/courses/:courseId/activity/:activityId/user/:userId/activity-grader/:submissionId',
        component: () => import('@/pages/courses/activity-grader/ActivityGrader.vue'),
        props: true,

        children: [
            {
                name: 'activity-grader-view',
                path: '',
                component: () => import('@/components/activity-grader/ActivityGraderView.vue'),
                meta: {
                    title: 'Quiz Grades',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view', subject: 'grade' },
                },
            },
        ],
    },
];
